import type { SensorMode, RfBoostSwitch, KeyScanRate } from '@rapoo/device-sdk'

/**
 * l05_多合一_3398_机械微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率 default: 3
 */
export function getBatteryLife_l05_pt0_3398_kt0_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate = 3,
): string {
  let batteryLife = '100'
  //1000
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '175-195'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  //2000
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  return batteryLife + 'h'
}

/**
 * l05_1T1R_3398_机械微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率 default: 3
 */
export function getBatteryLife_l05_pt1_3398_kt0_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate = 3,
): string {
  let batteryLife = '100'
  //1000
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  //2000
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  return batteryLife + 'h'
}

/**
 * l05_多合一_3950_光微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l05_pt0_3950_kt1_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //1000
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  //2000
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  return batteryLife + 'h'
}

/**
 * l05_1T1R_3950_光微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l05_pt1_3950_kt1_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //1000
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  //2000
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  return batteryLife + 'h'
}

/**
 * l05_多合一_3950_机械微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率 default: 3
 */
export function getBatteryLife_l05_pt0_3950_kt0_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate = 3,
): string {
  let batteryLife = '100'
  //1000
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  //2000
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  return batteryLife + 'h'
}

/**
 * l05_1T1R_3950_机械微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率 default: 3
 */
export function getBatteryLife_l05_pt1_3950_kt0_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate = 3,
): string {
  let batteryLife = '100'
  //1000
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  //2000
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  return batteryLife + 'h'
}
